
export function menuIcon() {
    $ = jQuery.noConflict();
    let $dropMenu = $("#menu-locations");
    $dropMenu.find(">.menu-item").prepend($("<span class='av-icon-char' aria-hidden='true' data-av_icon='' data-av_iconfont='fontello'></span>"));
    $dropMenu.find(".menu-item-has-children").click(function(e) {
        let $ul = $(this).find(".sub-menu");
        if($ul.is(":visible")) {
            $ul.fadeOut(400,  function () { $(this).hide() });
            $(".av-icon-char").removeClass("active");

        } else {
            $ul.fadeIn(400, function() { $(this).show() });
            $(e.currentTarget.firstElementChild).addClass("active");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/ts/src/helpers/menuIcon.ts